import React from 'react'
import ImageSlider from '../ImageSlider/index'

import './style.scss'

const TextWithoutSlider = ({ data }) => {
  return (
    <section className="c-text-w-slider bg-offwhite row mb-4 px-2 py-3 py-md-0">
      <div
        className="container pt-0 pt-sm-5 mb-sm-3 mb-lg-5 u-limit"
        dangerouslySetInnerHTML={{ __html: data.html }}
      />
    </section>
  )
}

export default TextWithoutSlider
